enum ApiEnvironments {
  PROD = "PROD",
  DEV = "DEV",
  STAGE = "STAGE",
}

const projectEnv = ApiEnvironments.PROD;

const getApiUrl = (env: ApiEnvironments): string => {
  switch (env) {
    case ApiEnvironments.PROD:
      return process.env.REACT_APP_PROD_API_URL || "";

    case ApiEnvironments.DEV:
      return process.env.REACT_APP_DEV_API_URL || "";

    case ApiEnvironments.STAGE:
      return process.env.REACT_APP_STAGE_API_URL || "";

    default:
      throw new Error("Unknown environment: " + env);
  }
};

// Set API_URL based on the current environment
export const API_URL = getApiUrl(projectEnv);

export enum LanguageReviewType {
  SPOKEN = "SPOKEN",
  TEACH = "TAUGHT",
  WORKANDEXPERIENC = "WORKANDEXPERIENCE",
}

export enum ActionType {
  ACCEPTED = "APPROVED",
  REJECT = "REJECTED",
}
